<p class="phase">{{ 'TGA.Phases.' + phase().translationKey | translate }}</p>
<div class="steps">
  @for (step of enhancedSteps(); track $index) {
    <app-step-card
      [stepNumber]="step.absoluteStepNumber"
      [stepName]="'TGA.Steps.' + step.translationKey | translate"
      [status]="step.status"
      [special]="step.special || false"
      [isLastOfPhase]="$index === phase().steps.length - 1"
      [isLastAbsoluteStep]="step.isLastAbsoluteStep"
      (stepClick)="onStepClick($event)"
      [isDisabled]="!(step.enabled ?? true)"
    />
  }
</div>
